module.exports = __webpack_public_path__ + "static/what-is-express-delivery-8a9af408c91bed638ead5f626ce303ef.png";